import { useTranslation } from 'react-i18next'
import { LogOut } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'

interface SessionExpiredModalProps {
  open: boolean
  onRelogin: () => void
}

export function SessionExpiredModal({ open, onRelogin }: SessionExpiredModalProps) {
  const { t } = useTranslation()

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <LogOut className="h-5 w-5 text-[var(--text-secondary)]" />
            {t('auth.sessionExpiredTitle')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('auth.sessionExpiredMessage')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button onClick={onRelogin}>
            {t('auth.sessionExpiredButton')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
